import BaseModalController from 'components/modal/js/controller/base-modal-controller';

export class BrandRankModalController extends BaseModalController {
    constructor($mdDialog) {
        super($mdDialog);
    }
}

BrandRankModalController.$inject = [
    '$mdDialog',
];
